import { Clock, Play } from 'lucide-react';
import { GlowCard } from '../../../../components/ui/spotlight-card';

interface HourOption {
  hour: number;
  label: string;
}

interface HourSelectorProps {
  hours: HourOption[];
  selectedHour: number | null;
  onSelectHour: (hour: number) => void;
  isLoading?: boolean;
}

function HourSelector({ hours, selectedHour, onSelectHour, isLoading }: HourSelectorProps) {
  if (isLoading) {
    return (
      <div className="py-8" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <p className="text-zinc-500 text-sm">Carregando horários...</p>
        </div>
      </div>
    );
  }

  if (!hours || hours.length === 0) {
    return (
      <div className="py-8" style={{ backgroundColor: '#0a0a0a' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <p className="text-zinc-500 text-sm">Nenhum vídeo encontrado para esta data.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="py-6" style={{ backgroundColor: '#0a0a0a' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center gap-2 mb-4">
          <Clock className="h-4 w-4 text-orange-400" />
          <h3 className="text-sm font-semibold text-white uppercase tracking-wider">Selecione o horário</h3>
        </div>
        <div className="flex flex-wrap gap-3">
          {hours.map((hourOption) => (
            <GlowCard
              key={hourOption.hour}
              glowColor={selectedHour === hourOption.hour ? 'orange' : 'blue'}
              className="cursor-pointer !p-0 !shadow-none"
            >
              <button
                onClick={() => onSelectHour(hourOption.hour)}
                className="relative z-10 flex items-center gap-2 px-5 py-3 rounded-2xl text-sm font-medium transition-all duration-200 border-none bg-transparent cursor-pointer w-full"
                style={{
                  color: selectedHour === hourOption.hour ? '#f29b2a' : '#a1a1aa',
                }}
              >
                <Play className="w-3 h-3" />
                {hourOption.label}
              </button>
            </GlowCard>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HourSelector;
